module.exports = __webpack_public_path__ + "static/media/3.Submersible Winding Wires.d15bd558.jpg";